import appFinesReimbursements from "../../views/appPlans/finesReimbursementsView.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "fines-reimbursements";
  const params = [
    "page', 'limit",
    "reason",
    "status",
    "start_date",
    "end_date",
    "date",
  ];

  $stateProvider.state("finesreimbursements", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appFinesReimbursements,
      },
    },
    reloadOnSearch: false,
    data: { title: "FinesReimbursements" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/finesReimbursements/finesReimbursements.urls.js